import {isNotNil} from 'ramda';

import {RecordInformationBody} from '@dms/api/core';

// A non-null recordInformation with every field empty is not a real pairing; treat it as none so
// the placeholder pair-CTA stays reachable and the Clear control only shows when there is something
// to clear.
export const hasRecordInformation = (info: RecordInformationBody | null | undefined): boolean =>
  isNotNil(info) &&
  (isNotNil(info.regPlate) ||
    isNotNil(info.vin) ||
    isNotNil(info.description) ||
    isNotNil(info.orderNumber));
